import { ApiProductType } from '../../../../types/ProductTypes';
import type { Deal } from '../../../types/Deal';
import type { WidgetProps } from '../../../types/WidgetProps';
import { WidgetType } from '../../../types/WidgetType';
import type Localiser from '../../Localiser';

import getInbodyLabel from './getInbodyLabel';

export default (
  localiser: Localiser,
  widget: WidgetProps['widget'],
  deal: Deal,
  linkText: string,
  showPrice: string,
): string => {
  switch (widget.type) {
    case WidgetType.DEAL:
      if (!linkText) {
        return localiser.translate('alternativeLinkText');
      }
      return linkText;
    case WidgetType.MERCHANT_LINK:
    case WidgetType.TABLETOP:
      if (showPrice === 'noPrice') {
        return '';
      }
      if (deal?.offer && deal?.product_type && deal.product_type === ApiProductType.multimedia) {
        if (showPrice === 'stream') {
          if (deal.offer?.price && Number(deal.offer.price) > 0) {
            return (
              deal.merchant &&
              localiser.translate('multimediaStreamOn', [String(deal.merchant.name)])
            );
          }
          return (
            deal.merchant &&
            localiser.translate('multimediaStreamOnWithoutFor', [String(deal.merchant.name)])
          );
        }
        if (showPrice === 'availableToStream') {
          return (
            deal.merchant &&
            localiser.translate('multimediaAvailableToStream', [String(deal.merchant.name)])
          );
        }
      }
      if (deal.offer && deal.product_type === ApiProductType.similar) {
        return `${localiser.translate('merchantLinkWidgetItemBuySimilarLabel')} ${
          deal?.merchant?.name || 'merchant'
        }`;
      }
      if (deal.offer.price && deal.merchant.name) {
        return localiser.translate('priceLinkAtMerchant', [String(deal.merchant.name)]);
      }
      return '';
    case WidgetType.STREAMING:
      if (showPrice === 'noPrice') {
        return '';
      }
      if (
        deal?.offer &&
        deal?.product_type &&
        (deal.product_type === ApiProductType.multimedia ||
          deal.product_type === ApiProductType.subscription)
      ) {
        return (
          deal?.merchant &&
          localiser.translate('multimediaWatchAtWithoutFor', [String(deal.merchant.name)])
        );
      }
      if (
        deal?.offer &&
        deal?.product_type &&
        (deal.product_type === ApiProductType.similar || !deal?.offer?.price)
      ) {
        return `${localiser.translate('merchantLinkWidgetItemBuySimilarLabel')} ${
          deal?.merchant?.name || 'merchant'
        }`;
      }
      return (
        deal?.merchant && localiser.translate('priceLinkAtMerchant', [String(deal.merchant.name)])
      );
    case WidgetType.INBODY:
      return getInbodyLabel(
        deal,
        linkText,
        localiser.language,
        localiser.translate.bind(localiser),
      );
    case WidgetType.PRODUCT_BLOCK:
      return localiser.translate('shopNow');
    default:
      return '';
  }
};
